import { Icon } from 'antd';
import * as React from 'react';

const Retry = (props) => (
  <svg width="11px" height="10px" viewBox="0 0 11 10" version="1.1" {...props}>
      <g id="UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="submit-evgm" transform="translate(-40.000000, -543.000000)" fill="#1890FF" fillRule="nonzero">
              <g id="Group-2-Copy" transform="translate(32.000000, 534.000000)">
                  <g id="Group-4" transform="translate(8.000000, 8.000000)">
                      <path d="M9.40351563,4.69602092 C8.62148438,3.91398967 7.58242188,3.48469279 6.47773438,3.48469279 L1.89492188,3.48469279 L3.4453125,1.93430217 C3.65859375,1.72102092 3.65859375,1.37512248 3.4453125,1.16047404 C3.23203125,0.945825605 2.88613281,0.947192792 2.67148438,1.16047404 L0.159960938,3.67336467 C0.057421875,3.77590373 5.27577981e-13,3.91535685 5.27577981e-13,4.06027873 C5.27577981e-13,4.2052006 0.057421875,4.34465373 0.159960938,4.44719279 L2.60039063,6.88762248 C2.70703125,6.9942631 2.84648438,7.04758342 2.98730469,7.04758342 C3.128125,7.04758342 3.26757813,6.9942631 3.37421875,6.88762248 C3.5875,6.67434123 3.5875,6.32844279 3.37421875,6.11379435 L1.8375,4.57844279 L6.47773438,4.57844279 C7.29121094,4.57844279 8.05546875,4.89563029 8.6296875,5.46984904 C9.20527344,6.04543498 9.52109375,6.80969279 9.52109375,7.62180217 L9.52109375,10.2468022 C9.52109375,10.5489506 9.76582031,10.7936772 10.0679688,10.7936772 C10.3701172,10.7936772 10.614847,10.5489506 10.614847,10.2468022 L10.614847,7.62180217 C10.6162109,6.51711467 10.1855469,5.47805217 9.40351563,4.69602092 Z" id="Shape"></path>
                  </g>
              </g>
          </g>
      </g>
  </svg>
);

export const RetryIcon = props => (
  <Icon  component={(innerProps) => {
    return Retry(Object.assign({}, innerProps, props));
  }}></Icon>
);
